// extracted by mini-css-extract-plugin
module.exports = {"logosWrapper":"Logos_logosWrapper__hGQlX","logosContainer":"Logos_logosContainer__o22db","image":"Logos_image__fdPSG"};